import React, { useState } from "react";
import { Card, CardBody, CardSubtitle, CardTitle } from "reactstrap";
import Button from "../../components/Button";
import FinancesCert from "../../components/FinancesCert/idnex";
import PageHeader from "../../components/PageHeader";

const TestFinancesCert = (props) => {
  const [isFinancesCertShow, setIsFinancesCertShow] = useState(false)
  const [result, setResult] = useState('')
  const submit = (data) => {
    setResult(data)
  }

  return (
    <div className="test-page">
      <PageHeader title="WeCake - Badge" />

      <Card>
        <CardBody>
          <CardTitle>Finances Cert</CardTitle>
          <br />
          <CardSubtitle className="mb-3">
            인증서 불러오기 테스트
          </CardSubtitle>
          <br />
          <Button onClick={() => { setIsFinancesCertShow(true) }}>
            인증서 불러오기
          </Button>

          <br />
          <br />
          결과
          <div className="badge-items">
            {JSON.stringify(result)}
          </div>
        </CardBody>
      </Card>

      <FinancesCert
        isShow={isFinancesCertShow}
        toggle={setIsFinancesCertShow}
        submit={submit}
      ></FinancesCert>

    </div>
  );
};

export default TestFinancesCert;
